import React from 'react';
import { useQuery, gql } from '@apollo/client';
import { TableRow, TableCell, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

function Verses({ verseList }) {
  const versesQuery = gql`
    query($id: [String!]!) {
      chapterVerses(id: $id) {
        id
        verseNum
        text
        textDirection
      }
    }
  `;

  const { error: verseError, data: versesData, loading: loading } = useQuery(versesQuery, {
    variables: { id: verseList }
  });
  if (loading) {
    return (
      <TableRow>
        <center>
          <TableCell>
            <CircularProgress />
          </TableCell>
        </center>
      </TableRow>
    );
  }
  if (verseError) {
    console.log('Error fetching: ', verseError);
    return undefined;
  }
  let versesArray = [];
  if (!loading) {
    let maxRowSize = 0;
    for (let i = 0; i < verseList.length; i++) {
      if (
        versesData &&
        versesData.chapterVerses[i] &&
        versesData.chapterVerses[i].length > maxRowSize
      ) {
        maxRowSize = versesData.chapterVerses[i].length;
      }
    }
    for (let i = 0; i < maxRowSize; i++) {
      let row = [];
      for (let j = 0; j < verseList.length; j++) {
        if (versesData && versesData.chapterVerses[j] && versesData.chapterVerses[j][i]) {
          row.push(versesData.chapterVerses[j][i]);
        } else {
          row.push({});
        }
      }
      versesArray.push(row);
    }
  }
  return versesArray.map(row => (
    <TableRow>
      {row.map(cell => (
        <TableCell key={cell.id} dir={cell.textDirection} style={{ textAlign: 'justify' }}>
          <Typography variant="h6" key={cell.id}>
            {<sup>{cell.verseNum}</sup>} {cell.text}
          </Typography>
        </TableCell>
      ))}
    </TableRow>
  ));

  // <p>Testing</p>
}
export default Verses;
